<template>
  <div style="height: 50vh">
    <div class="my-6">
      <h1>Une erreur est survenue...</h1>
    </div>

    <p class="mb-12">
      Une erreur est survenue lors du paiement. Veuillez contacter le support d'Amnistie internationale pour connaitre les détails de l'erreur et
      procéder à votre donation.
    </p>
    <template v-if="$route.params.idReference">
      <hr class="mb-3" />
      <p>Numéro de référence: {{ $route.params.idReference }}</p>
    </template>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>